/** Verweise auf 3D-Objekte für das Anklicken (Raycasting). */
import type * as THREE from "three";
import type { LabelMesh } from "../engine/rooms";

/** Möbel-Id → Group in der Szene */
export const itemObjects = new Map<string, THREE.Object3D>();
/** alle Raumbeschriftungen */
export const labelMeshes: LabelMesh[] = [];
/** Leitungs-/Anschluss-Id → Group (userData.lineSel) */
export const lineObjects = new Map<string, THREE.Object3D>();
